/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Save_FailedInputs */

const en_profile_save_failed = /** @type {(inputs: Profile_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save profile`)
};

const es_profile_save_failed = /** @type {(inputs: Profile_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al guardar el perfil`)
};

/**
* | output |
* | --- |
* | "Failed to save profile" |
*
* @param {Profile_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_save_failed = /** @type {((inputs?: Profile_Save_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Save_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_save_failed(inputs)
	return en_profile_save_failed(inputs)
});